import { Avatar, Button, createStyles, LinearProgress, makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";
import PermContactCalendarIcon from '@material-ui/icons/PermContactCalendar';
import { withStyles } from "@material-ui/styles";
import clsx from 'clsx';
import { format } from "date-fns";
import { STATUS_PROCESS, STATUS_PROCESS_NAME, VISA_TYPE_NAME } from "libs/configs/constant";
import { DashboardHeader } from "pages/admin/dashboard/components/general";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  wrapChart: {
    width: '100%',
    height: 'calc(100% - 35px)',
    overflow: 'auto',
    '&::-webkit-scrollbar': { width: 5, },
    '&::-webkit-scrollbar-thumb': { background: '#999999' }
  },
  chart: {
    width: '100%',
    height: '100%',
  },
  tableHead2: {
    color: '#8898AA',
    textAlign: 'center',
    padding: 0
  },
  itemRow: {
    fontSize: '12px !important',
    padding: '5px !important'
  },
  center: {
    textAlign: 'center'
  },
  rounded: {
    width: "22px", height: "21px", paddingTop: "1px", backgroundColor: '#756BF8', cursor: 'pointer'
  },
  btnView: {
    color: "white", fontSize: "10px", backgroundColor: "#EE9B54", padding: "1px 5px"
  },
  progressBar: {

  },
  numProgress: {
    textAlign: "right", color: "slategray", fontSize: "10px"
  }
}));


const ProgressBar = withStyles((theme) =>
  createStyles({
    colorPrimary: {
      backgroundColor: 'whitesmoke',
    },
    bar: {
      backgroundColor: '#6DD570',
    },
  }),
)(LinearProgress);

const ProgressBarYellow = withStyles((theme) =>
  createStyles({
    colorPrimary: {
      backgroundColor: 'whitesmoke',
    },
    bar: {
      backgroundColor: '#EF5B58',
    },
  }),
)(LinearProgress);


const ProgressBarRed = withStyles((theme) =>
  createStyles({
    colorPrimary: {

      backgroundColor: 'whitesmoke',
    },
    bar: {
      backgroundColor: '#EF5B58',
    },
  }),
)(LinearProgress);

const StyledTableCell = withStyles((theme) => ({
  head: {
    // backgroundColor: theme.palette.common.black,
    color: '#707070',
    fontSize: 12
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      // backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);


const data = [
  {
    date: '2021-01-01 14:00',
    applicant: 'ธีรวัจน์ บุรวัตร์',
    type: 'Smart S',
    progress: 100,
    status: 'Approved',
    step: '8/8'
  },
  {
    date: '2021-01-10 15:00',
    applicant: 'ทศพร สิริรักษ์',
    docNo: 'T00002',
    type: 'Smart E',
    progress: 60,
    status: 'Rejected',
    step: '5/8'
  },
  {
    date: '2021-01-01 14:00',
    applicant: 'เกษม วงศ์',
    type: 'Smart I',
    progress: 15,
    status: 'Processing',
    step: '1/8'
  },
  {
    date: '2021-01-01 14:00',
    applicant: 'บุญมี สุกพร่ำ',
    type: 'Smart S',
    progress: 20,
    status: 'Processing',
    step: '2/8'
  },
  {
    date: '2021-01-01 14:00',
    applicant: 'สามารถ อลงกรณ์',
    type: 'Smart I',
    progress: 100,
    status: 'Approved',
    step: '8/8'
  },
]

function CheckStatus(props) {
  const classes = useStyles();
  const _data = props?.data || [];
  const history = useHistory();
  const normalise = (value, max) => (value - 0) * 100 / (max - 0);

  return (
    <>
      <div>
        <DashboardHeader title="Check Status" onSelectViewAll={() => {
          props.onSelectViewAll()
        }} />
      </div>
      <div className={classes.wrapChart}>

        <div style={{ marginTop: 5 }}>
          <div className={clsx(classes.warpData, classes.wrapTable)}>
            <TableContainer component={Paper}>
              <Table size="small" aria-label="customized table">
                <TableHead >
                  <TableRow>
                    <StyledTableCell className={clsx(classes.tableHead2, classes.center)}
                      style={{ width: 130 }}>
                      Date
                    </StyledTableCell>
                    <StyledTableCell className={clsx(classes.tableHead2, classes.center)}
                      style={{ width: 155 }}>Applicant</StyledTableCell>
                    <StyledTableCell className={clsx(classes.tableHead2, classes.center)}
                      style={{ width: 90 }}>Doc No.</StyledTableCell>
                    <StyledTableCell className={clsx(classes.tableHead2, classes.center)}
                      style={{ width: 60 }}>Type</StyledTableCell>
                    <StyledTableCell className={clsx(classes.tableHead2, classes.center)}
                      style={{ width: 100 }}>Progress</StyledTableCell>
                    <StyledTableCell className={clsx(classes.tableHead2, classes.center)}
                      style={{ width: 100 }}>Status</StyledTableCell>
                    <StyledTableCell className={clsx(classes.tableHead2, classes.center)}
                      style={{ width: 50 }}>Contact</StyledTableCell>
                    <StyledTableCell className={clsx(classes.tableHead2, classes.center)}
                      style={{ width: 100, paddingRight: 0 }}>Action</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>

                  {/* docNo: "SmartR21120005"
draftId: "0d9be588-4804-4a61-a156-69b560835504"
personalFirstName: "Theerawat"
personalLastName: "Burawat"
progress: 0
smartDate: "2021-12-29T10:07:23.58"
smartserviceId: "1ec46938-5bf4-2e83-2dd0-1c9fe7ce95d5"
staffId: "852744a4-98e8-4f98-bf18-2db284bcf485"
status: "R" */}
                  {
                    _data.map((r, index) => (
                      <StyledTableRow key={r.draftId}>
                        <StyledTableCell component="th" scope="row" className={clsx(classes.itemRow, classes.center)}>
                          {format(new Date(r.smartDate), "yyyy-MM-dd")}
                        </StyledTableCell>
                        <StyledTableCell className={clsx(classes.itemRow, classes.center)}>
                          {r.personalFirstName} {r.personalLastName}
                        </StyledTableCell>
                        <StyledTableCell className={clsx(classes.itemRow, classes.center)}>
                          {r.docNo}
                        </StyledTableCell>
                        <StyledTableCell className={clsx(classes.itemRow, classes.center)}>
                          {VISA_TYPE_NAME[r?.smartserviceId]}
                        </StyledTableCell>
                        <StyledTableCell className={clsx(classes.itemRow, classes.center)}>

                          <div className={clsx(classes.numProgress)}>
                            {r.step}
                          </div>
                          {/* <ProgressBar
                            className="progressBar"
                            variant="determinate"
                            // color="error"
                            value={normalise(+r?.progress, +r?.maxProgress)}
                          /> */}
                          {
                            +r?.progress === +r?.maxProgress &&
                            <ProgressBar
                              className="progressBar"
                              variant="determinate"
                              // color="error"
                              value={normalise(+r?.progress, +r?.maxProgress)}
                            />
                          }
                          {
                            +r?.status === STATUS_PROCESS.FinalRejected &&
                            <ProgressBarRed
                              className="progressBar"
                              variant="determinate"
                              // color="error"
                              value={normalise(+r?.progress, +r?.maxProgress)}
                            />
                          }
                          {
                            +r?.status !== STATUS_PROCESS.FinalRejected &&
                            +r?.progress !== +r?.maxProgress &&
                            <ProgressBarYellow
                              className="progressBar"
                              variant="determinate"
                              // color="error"
                              value={normalise(+r?.progress, +r?.maxProgress)}
                            />
                          }
                          {/* {
                            r.status == 'R' &&
                            <ProgressBarRed
                              className="progressBar"
                              variant="determinate"
                              // color="error"
                              value={normalise(+r?.progress, +r?.maxProgress)}
                            />
                          }
                          {
                            r.status == 'FA' && r.progress === r.maxProgress &&
                            <ProgressBar
                              className="progressBar"
                              variant="determinate"
                              // color="error"
                              value={normalise(+r?.progress, +r?.maxProgress)}
                            />
                          }
                          {
                            r.status != 'R' && r.progress < r.maxProgress &&
                            <ProgressBarYellow
                              className="progressBar"
                              variant="determinate"
                              // color="error"
                              value={normalise(+r?.progress, +r?.maxProgress)}
                            />
                          } */}
                        </StyledTableCell>
                        <StyledTableCell className={clsx(classes.itemRow, classes.center)}>
                          {STATUS_PROCESS_NAME[r.status]}
                        </StyledTableCell>
                        <StyledTableCell className={clsx(classes.itemRow, classes.center)}>
                          <div style={{ display: "flex", justifyContent: "center" }}>
                            <Avatar variant="rounded" className={classes.rounded}>
                              <PermContactCalendarIcon />
                            </Avatar>
                          </div>


                        </StyledTableCell>
                        <StyledTableCell className={clsx(classes.itemRow, classes.center)}>
                          <Button
                            variant="contained"
                            size="small"
                            className={classes.btnView}
                            onClick={() => {
                              history.push(`/admin/smart-visa/document/${r.draftId}`)
                            }}
                          >
                            View
                          </Button>
                        </StyledTableCell>


                      </StyledTableRow>
                    ))
                  }



                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>

      </div>
    </>
  )
}


export default CheckStatus;